import { processDocumentEntries, RolodexDocumentEntry } from 'features/files'
import { useRolodexEntries } from 'features/rolodex'
import { useMemo } from 'react'

export const useDocument = (entryId: string | null) => {
  const { entries, isLoading } = useRolodexEntries(
    entryId ? { ids: [entryId] } : undefined
  )

  const document = useMemo((): RolodexDocumentEntry | null => {
    if (!entries || entries.length === 0) return null
    const processed = processDocumentEntries(entries)
    return processed[0] || null
  }, [entries])

  return {
    document,
    isLoading,
  }
}
